import { Container, Input } from 'components/atoms';
import ViewHint from 'components/molecules/hint/ViewHint';

import { t } from 'i18next';
import { PiPhone, PiUserCircle } from 'react-icons/pi';
import { useGetLabel } from 'services/labels';
import { CUSTOMER_TYPE } from 'services/labels/types';

const LabelContactDetails = () => {
  const { data: label, isLoading } = useGetLabel(false);

  return (
    <>
      <div />
      <ViewHint hintId="label-contact-details" />

      <Input.ComplexWrapper sizes={[50, 50]}>
        <Input.Text
          name="firstName"
          label={t('input.label.firstName')}
          value={label?.firstName}
          readOnly
        />
        <Input.Text
          name="lastName"
          label={t('input.label.lastName')}
          value={label?.lastName}
          readOnly
        />
      </Input.ComplexWrapper>

      <Input.Text name="email" label={t('input.label.email')} value={label?.email} readOnly />
      <Input.ComplexWrapper sizes={[40, 60]}>
        <Input.Text
          name="phoneNumberPrefix"
          label={t('input.label.phoneNumberCodeShort')}
          placeholder=""
          readOnly
          value={label?.phoneNumberPrefix}
        />
        <Input.Text
          name="phoneNumber"
          label={t('input.label.phoneNumber')}
          readOnly
          value={label?.phoneNumberNumber}
        />
      </Input.ComplexWrapper>
      {label?.customerTypeId === CUSTOMER_TYPE.Physical && (
        <Input.Text
          className="readonly-date"
          max={new Date().toISOString().split('T')[0]}
          min={'1900-01-01'}
          label={t('input.label.dateOfBirth')}
          type="date"
          value={label.dateOfBirth ? label.dateOfBirth.split('T')[0] : ''}
          name="dateOfBirth"
          readOnly
        />
      )}
    </>
  );
};

export default LabelContactDetails;
